(function () {
  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var FAIXAS = [
    [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'],
    [40000, 48999, 'BA'], [49000, 49999, 'SE'], [50000, 56999, 'PE'], [57000, 57999, 'AL'],
    [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'],
    [69300, 69399, 'RR'], [69400, 69899, 'AM'], [69900, 69999, 'AC'], [70000, 72799, 'DF'],
    [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [79000, 79999, 'MS'], [80000, 87999, 'PR'],
    [88000, 89999, 'SC'], [90000, 99999, 'RS']
  ];

  function estadoDoCep(cep) {
    var prefixo = Number(cep.slice(0, 5));
    for (var i = 0; i < FAIXAS.length; i++) {
      if (prefixo >= FAIXAS[i][0] && prefixo <= FAIXAS[i][1]) return FAIXAS[i][2];
    }
    return '';
  }

  function reais(valor) {
    return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function escrever(saida, texto) {
    var p = document.createElement('p');
    p.textContent = texto;
    saida.replaceChildren(p);
  }

  function listar(saida, fretes, temFrescal) {
    if (!fretes.length) {
      escrever(saida, temFrescal
        ? 'Com a linguiça frescal no carrinho, o pedido só sai por retirada na loja. Tire ela do carrinho para receber em casa.'
        : 'Não encontramos frete para esse CEP.');
      return;
    }
    var lista = document.createElement('ul');
    fretes
      .slice()
      .sort(function (a, b) { return Number(a.price) - Number(b.price); })
      .slice(0, 3)
      .forEach(function (frete) {
        var dias = frete.delivery_days && frete.delivery_days.length ? frete.delivery_days[frete.delivery_days.length - 1] : 0;
        var nome = document.createElement('span');
        var preco = document.createElement('strong');
        var item = document.createElement('li');
        nome.textContent = frete.name + (dias ? ', ' + dias + (dias > 1 ? ' dias úteis' : ' dia útil') : '');
        preco.textContent = Number(frete.price) > 0 ? reais(frete.price) : 'Grátis';
        item.append(nome, preco);
        lista.append(item);
      });
    saida.replaceChildren(lista);
  }

  function esperar(ms) {
    return new Promise(function (pronto) { setTimeout(pronto, ms); });
  }

  function buscarFretes(query, tentativas) {
    return fetch(raiz + 'cart/async_shipping_rates.json?' + query, { headers: { Accept: 'application/json' } })
      .then(function (resposta) {
        if (resposta.status === 422) throw new Error('cep');
        return resposta.json();
      })
      .then(function (dados) {
        if (dados && dados.shipping_rates) return dados.shipping_rates;
        if (tentativas <= 0) throw new Error('tempo');
        return esperar(700).then(function () { return buscarFretes(query, tentativas - 1); });
      });
  }

  document.addEventListener('click', function (event) {
    var botao = event.target.closest('[data-da-add]');
    if (!botao) return;
    event.preventDefault();
    botao.disabled = true;
    fetch(raiz + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(botao.dataset.daAdd), quantity: 1 }] })
    })
      .then(function () { return fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (resposta) { return resposta.json(); })
      .then(function (carrinho) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: carrinho, sourceId: 'da-frete', data: { source: 'da-frete', itemCount: carrinho.item_count } }
        }));
      })
      .catch(function () { botao.disabled = false; });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-da-cep-form]');
    if (!form) return;
    event.preventDefault();
    var caixa = form.closest('[data-da-frete]');
    var saida = caixa.querySelector('[data-da-cep-res]');
    var cep = (form.elements.cep.value || '').replace(/\D/g, '');
    var estado = cep.length === 8 ? estadoDoCep(cep) : '';
    if (!estado) {
      escrever(saida, 'Confira o CEP: são 8 números.');
      return;
    }
    escrever(saida, 'Calculando...');
    var query = 'shipping_address%5Bzip%5D=' + cep + '&shipping_address%5Bcountry%5D=BR&shipping_address%5Bprovince%5D=' + estado;
    fetch(raiz + 'cart/prepare_shipping_rates.json?' + query, { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function (resposta) {
        if (resposta.status === 422) throw new Error('cep');
        return buscarFretes(query, 15);
      })
      .then(function (fretes) { listar(saida, fretes, caixa.hasAttribute('data-frescal')); })
      .catch(function (erro) {
        escrever(saida, erro.message === 'cep' ? 'Não encontramos esse CEP. Confira o número.' : 'Não deu para calcular agora. O frete aparece no checkout.');
      });
  });
})();
